import React from 'react';
import {PropTypes} from 'prop-types';
import ScrollToLink from '../scroll_to_link/index.jsx';
import { PROFILE_BUTTON, ANIMATION_SCROLL_TIME } from '../constants';

const ProfileButton = ({ url, openInNewWindow, text }) => {
    return (url.includes('#') ?
        <ScrollToLink
            href={url}
            className="c-profile__button btn btn-profile-action btn-hs"
            animationTime={ANIMATION_SCROLL_TIME}
        >
            {text}
        </ScrollToLink> :
        <a
            className="c-profile__button btn btn-profile-action btn-hs"
            href={url}
            target={openInNewWindow ? '_blank' : '_self'}
            rel={openInNewWindow ? 'noopener' : null}
        >
            {text}
        </a>
    );
};

ProfileButton.defaultProps = {
    openInNewWindow: PROFILE_BUTTON.OPEN_IN_NEW_WINDOW
};

ProfileButton.propTypes = {
    url: PropTypes.string.isRequired,
    openInNewWindow: PropTypes.bool,
    text: PropTypes.string.isRequired
};

export default ProfileButton;



// WEBPACK FOOTER //
// ./components/profile/profile_button.jsx